<template>
    <b-container>
        <h3>Einladung erstellen:</h3>
        <hr class="mt-4 mb-4">
        <h4>Name:</h4>
        <b-form-input
            id="input-1"
            v-model="newInvitation.name"
            required
            class="mb-2"
        ></b-form-input>
        <h4>Email:</h4>
        <b-form-input
            id="input-1"
            v-model="newInvitation.email"
            required
            type="email"
            class="mb-2"
        ></b-form-input>
        <h4>Rechte:</h4>
        <b-form-group
            class="mb-2"
        >
            <b-checkbox
                v-for="permission in permissions"
                v-bind:key="permission.value"
                v-model="newInvitation[permission.value]"
            >
                {{ permission.text }}
            </b-checkbox>
        </b-form-group>
        <hr class="mt-4 mb-4">
        <b-button variant="outline-success" @click="storeInvitation(newInvitation)" block>{{ create ? 'Erstellen' : 'Speichern' }}</b-button>
        <b-button variant="outline-danger" block class="mb-4" v-if="!create">Löschen</b-button>
    </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "InitationCreate",
    props: {
        create: Boolean
    },
    data() {
        return {
            permissions: [
                { text: 'Artikel', value: 'articles' },
                { text: 'Kalender', value: 'calendar' },
                { text: 'Hinweise', value: 'warnings' },
                { text: 'Aufbau & Inhalt', value: 'cms' },
                { text: 'Entschuldigungen', value: 'excuses' },
                { text: 'Schnellzugriffe', value: 'quickaccess' },
                { text: 'Benutzer/Einladungen/Rechte', value: 'permissions' },
            ]
        }
    },
    computed: {
        ...mapGetters([
            'getNewInvitation'
        ]),
        newInvitation() {
            return this.getNewInvitation
        },
    },
    methods: {
        ...mapActions([
            'storeInvitation'
        ])
    },
    mounted() {
        for(const permission of this.permissions) this.newInvitation[permission.value] = false;
    }
}
</script>

<style scoped>

</style>
